import { NewOrderType, TNewOrderType } from "@/entities/new-order";

export const getTableTitle = (orderType: TNewOrderType) => {
  const orderTitles = {
    [NewOrderType.rate]: "Rates",
    [NewOrderType.install]: "Keywords",
    [NewOrderType.install_with_views]: "Keywords",
    [NewOrderType.install_bp]: "",
  };

  return orderTitles[orderType];
};
